import { getAutoRenderJobs } from './renders';
import type { StatusReportData } from '../types/renders';
import type { Project, RenderingProject } from '../types/project';
import { getProject } from './projects';

export class AutoRenderingFetcher {
  private _local: StatusReportData | null = null;
  private _allRenderings: RenderingProject[] = [];

  /**
   * Fetches all projects and updates the local cache.
   * Returns the full status report data.
   */
  async fetchAllProjects(): Promise<StatusReportData> {
    try {
      const data = await getAutoRenderJobs();
      this._local = data;
      this._allRenderings = data.allProjects || [];
      return data;
    } catch (error) {
      console.error('Failed to fetch auto render jobs:', error);
      throw error;
    }
  }

  /**
   * Searches for a project in the local memory cache.
   * @param projectId The ID of the project to find.
   */
  /**
   * Searches for a project in the local memory cache.
   * @param projectId The ID of the project to find.
   */
  fetchProject(projectId: string): RenderingProject | undefined {
    if (!this._allRenderings.length) {
      return undefined;
    }
    return this._allRenderings.find(
      (p) => p.id === projectId || p.projectId === projectId || p.pk === projectId
    );
  }

  /**
   * Returns the currently cached data.
   */
  getCachedData(): StatusReportData | null {
    return this._local;
  }

  /**
   * Fetches the full project details from the API.
   * @param projectId The ID of the project to fetch.
   */
  async fetchFullProject(projectId: string): Promise<Project> {
    try {
      const project = await getProject(projectId);
      return project;
    } catch (error) {
      console.error(`Failed to fetch full project details for ${projectId}:`, error);
      throw error;
    }
  }
}

export const autoRenderingFetcher = new AutoRenderingFetcher();
